export default {
  // 標題
  time: "時間",

  // 占位符
  pleaseSelect: "請選擇",
  startDate: "開始日期",
  endDate: "結束日期",

  // 功能開關選項
  surveyData: "調證數據",
  firstInflow: "首筆流入",
  swapContract: "swap合約",

  // 消息提示
  currencyUpdateSuccess: "幣種修改成功",
  timeUpdateSuccess: "時間修改成功",
  tagUpdateSuccess: "標籤修改成功",
  switchUpdateSuccess: "開關修改成功",
  filterSuccess: "篩選成功",
  updateSuccess: "修改成功",
};
